import React from 'react';
import PropTypes from 'prop-types';
import { zeroPad } from 'react-countdown';

const Timer = ({ days, hours, minutes, seconds }) => {
  if (!days && hours) {
    return (
      <>
        <span>
          {zeroPad(hours)}:{zeroPad(minutes)}
        </span>{' '}
        Hours
      </>
    );
  }
  if (!days && !hours && minutes) {
    return (
      <>
        <span>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>{' '}
        Minutes
      </>
    );
  }
  if (!days && !hours && !minutes) {
    return (
      <>
        <span>00:{zeroPad(seconds)}</span> Seconds
      </>
    );
  }
  return (
    <>
      <span>{zeroPad(days)}</span> Days, <span>{zeroPad(hours)}</span> Hours
    </>
  );
};

Timer.propTypes = {
  days: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  seconds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Timer;
